import React, { useRef, useState } from 'react';
import './register.scss';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import InfoArea from "./InfoArea/infoArea";
import FormArea from "./FormArea/formArea";
import Header from "./Header/header";
import SuccessScreen from "./SuccessScreen/successScreen";
import { REGISTRATION_END_DATE } from '../../utils/constants';
import RegistrationClosed from './RegistrationClosed/RegistrationClosed';
import { isRegistrationOpen } from '../../utils/helpers';

export default function Register() {
  const formRef = useRef(null);
  const [successMessage, setSuccessMessage] = useState(false);
  const [credentials, setCredentials] = useState({});

  if (successMessage) {
    return (
      <div id="success-page">
        <Header />
        <SuccessScreen credentials={credentials} />
      </div>
    );
  }

  return (
    <div id="registration-page">
      <Header />
      <div className="content-area">
        <InfoArea formRef={formRef} />
        {
          isRegistrationOpen() ?
            <FormArea formRef={formRef} successMessage={setSuccessMessage} credentials={setCredentials} /> :
            <RegistrationClosed formRef={formRef} />
        }
      </div>
    </div>
  );
};
